// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetVillageListRequest, TGetVillageListModel, IMappers, TGetVillageListResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetVillageListResponseSchema } from '../../entities/entities/GetVillageListResponseSchema';
import type { IErrorResponseSchema } from '../../../../../shared/repositories/countryside-search/entities/schemas/ErrorResponseSchema';

export function createGetVillageListModel(parameters: TGetVillageListRequest): TGetVillageListModel {
  return {
    v: 1,
    apiType: 'private',
    method: 'POST',
    microserviceName: 'countryside-search',
    pathApi: '/v1/get-village-list/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetVillageListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetVillageListRequest;
}

export async function fetchGetVillageList<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetVillageListOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetVillageListResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetVillageListModel(parameters),
    config,
  )) as FetchResponse<TGetVillageListResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetVillageListResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetVillageListResponse>;
}
